export const AppTabs = {
  HOME: {
    id: "home",
    label: "Home",
    path: "/",
  },
  CFP_FORM: {
    id: "cfpForm",
    label: "Form",
    path: "/cfpForm",
  },
  ABOUT: {
    id: "about",
    label: "About",
    path: "/about",
  },
};
